import Big from "big.js";

import { EarnOfferData } from "@/components/EarnOffer";
import { formatNumber } from "@/utils/numbers";

export const getOfferDescription = (
  description: string,
  unit: string = "%",
) => {
  return (apy: number) => {
    const apyBig = Big(apy);
    return `${formatNumber(apyBig, false, 2, false)}${unit} – ${description}`;
  };
};

export type OfferData = EarnOfferData & { url: string };

export const offers: OfferData[] = [
  {
    icon: "/images/stonfi.svg",
    name: "STON.fi",
    sections: [
      {
        color: "blue",
        description: getOfferDescription("Tonstakers Earn"),
        value: 0,
        apyKey: "ston",
      },
    ],
    url: "https://app.ston.fi/pools/EQCdQZq6x_jrm4wAha4KUIVa0rtrz7avo6th9IWrIIa4RPSi?farmTab=nfts",
  },
  {
    icon: "/images/dedust.svg",
    name: "DeDust.io",
    sections: [
      {
        color: "blue",
        description: getOfferDescription("Tonstakers Earn"),
        value: 0,
        apyKey: "dedust",
      },
      // {
      //   color: "cyan",
      //   description: getOfferDescription("Tonstakers Earn"),
      //   value: 0,
      //   apyKey: "dedustboost",
      // },
    ],
    url: "https://app.dedust.io/pools/EQBkh7Mc411WTYF0o085MtwJpYpvGhZOMBphhIFzEpzlVODp",
  },
  {
    icon: "/images/evaa.svg",
    name: "EVAA",
    sections: [
      // {
      //   color: "green",
      //   description: getOfferDescription("EVAA XP Rewards", " XP"),
      //   value: 2,
      //   ignoreValue: true,
      // },
      {
        color: "blue",
        description: getOfferDescription("Tonstakers Earn"),
        value: 0,
        apyKey: "evaa",
      },
    ],
    url: "https://app.evaa.finance?referral=UQAH0W08NGJnYrhxqMAJCrslz9sXcp16_CiJJYdBkgYj8uQe",
  },
];
